import { lazy } from "react";
import { LAYOUTS } from "../constant";
import ROLES from "static/roles";

//public Route
const Login = lazy(() => import("../pages/Login"));
const ForgotPassword = lazy(() => import("../pages/Login/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/Login/ResetPassword"));

// common routes
const Dashboard = lazy(() => import("../pages/Dashboard"));
const Activity = lazy(() => import("../pages/Activity"));
const SellInvoice = lazy(() => import("../pages/Sell-Invoice"));
const SellInvoiceAdd = lazy(() => import("../pages/Sell-Invoice/Form"));
const Memo = lazy(() => import("../pages/Memo"));
const CreateMemo = lazy(() => import("../pages/Memo/Form"));
const ManageInvoices = lazy(() => import("../pages/Sell-Invoice/Preview"));
const Returns = lazy(() => import("../pages/Returns"));
const ReturnPreview = lazy(() => import("../pages/Returns/Preview"));
const MemoPreview = lazy(() => import("../pages/Memo/Preview"));
const Stock = lazy(() => import("../pages/Stock"));
const StockForm = lazy(() => import("../pages/Stock/Form"));
const StockHistory = lazy(() => import("../pages/Stock/History"));
const Expense = lazy(() => import("../pages/Expense"));
const ExpenseForm = lazy(() => import("../pages/Expense/Form"));
const Customer = lazy(() => import("../pages/Customer"));
const CustomerAdd = lazy(() => import("../pages/Customer/Form"));
const RolesPermission = lazy(() => import("../pages/Roles-Permission/RolesPermission"));
const RolesPermissionForm = lazy(() => import("../pages/Roles-Permission/Form"));
const ReportsAnalytics = lazy(() => import("../pages/Reports-Analytics/ReportsAnalytics"));
const Purchase = lazy(() => import("../pages/Purchase"));
const PurchaseForm = lazy(() => import("../pages/Purchase/Form"));
const Payment = lazy(() => import("../pages/Payment"));
const PaymentForm = lazy(() => import("../pages/Payment/Form"));
const PaymentPreview = lazy(() => import("../pages/Payment/Preview"));
const ProfileUpdate = lazy(() => import("../pages/Profile-Update"));
const PasswordChange = lazy(() => import("../pages/Password-Change"));

const { MAIN, DASHBOARD_LAYOUT } = LAYOUTS;
const { SUPER_ADMIN, ADMIN, FINANCE, SALES } = ROLES;

export const publicRoutes = [
    {
        path: "/login",
        element: Login,
        title: "Login",
        layout: ""
    },
    {
        path: "/forgot-password",
        element: ForgotPassword,
        title: "ForgotPassword",
        layout: ""
    },
    {
        path: "/reset-password",
        element: ResetPassword,
        title: "ResetPassword",
        layout: ""
    }
];

export const privateRoutes = [
    {
        path: '/',
        element: Dashboard,
        title: "Dashboard",
        layout: DASHBOARD_LAYOUT,
        breadcrumb: ["Dashboard"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/activity',
        element: Activity,
        title: "Activity",
        layout: MAIN,
        breadcrumb: ["Activity"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/sell-invoice',
        element: SellInvoice,
        title: "Sell-Invoice",
        layout: MAIN,
        breadcrumb: ["Management", "Sell-Invoice"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/sell-invoice/add',
        element: SellInvoiceAdd,
        title: "Sell-Invoice - Add",
        layout: MAIN,
        breadcrumb: ["Management", "Sell-Invoice", "Add"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/sell-invoice/edit/:sellInvoiceId',
        element: SellInvoiceAdd,
        title: "Sell-Invoice - Edit",
        layout: MAIN,
        breadcrumb: ["Management", "Sell-Invoice", "Edit"],
        allowedRoles: [SUPER_ADMIN]
    },
    {
        path: '/sell-invoice/preview/:sellInvoiceId',
        element: ManageInvoices,
        title: "Sell-Invoice / Manage invoices",
        layout: MAIN,
        breadcrumb: ["Management", "Sell-Invoice", "Manage Invoices"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/returns',
        element: Returns,
        title: "Returns",
        layout: MAIN,
        breadcrumb: ["Management", "Returns"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/returns/preview/:returnId',
        element: ReturnPreview,
        title: "Return Preview",
        layout: MAIN,
        breadcrumb: ["Management", "Returns", "Preview"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/memo',
        element: Memo,
        title: "Memo",
        layout: MAIN,
        breadcrumb: ["Management", "Memo"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/memo/add',
        element: CreateMemo,
        title: "MemoAdd",
        layout: MAIN,
        breadcrumb: ["Management", "Memo", "Add"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/memo/edit/:memoId',
        element: CreateMemo,
        title: "MemoEdit",
        layout: MAIN,
        breadcrumb: ["Management", "Memo", "Edit"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/memo/preview/:memoId',
        element: MemoPreview,
        title: "Memo Preview",
        layout: MAIN,
        breadcrumb: ["Management", "Memo", "Preview"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/stock',
        element: Stock,
        title: "Stock",
        layout: MAIN,
        breadcrumb: ["Management", "Stock"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/stock/add',
        element: StockForm,
        title: "StockAdd",
        layout: MAIN,
        breadcrumb: ["Management", "Stock", "Add"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/stock/edit/:stockId',
        element: StockForm,
        title: "StockEdit",
        layout: MAIN,
        breadcrumb: ["Management", "Stock", "Edit"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/stock/history/:stockId',
        element: StockHistory,
        title: "Stock History",
        layout: MAIN,
        breadcrumb: ["Management", "Stock", "History"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/expense',
        element: Expense,
        title: "Expense",
        layout: MAIN,
        breadcrumb: ["Management", "Expense"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE]
    },
    {
        path: '/expense/add',
        element: ExpenseForm,
        title: "ExpenseAdd",
        layout: MAIN,
        breadcrumb: ["Management", "Expense", "Add"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE]
    },
    {
        path: '/expense/edit/:expenseId',
        element: ExpenseForm,
        title: "ExpenseEdit",
        layout: MAIN,
        breadcrumb: ["Management", "Expense", "Edit"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE]
    },
    {
        path: '/customer',
        element: Customer,
        title: "Customer",
        layout: MAIN,
        breadcrumb: ["Management", "Customer"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/vendor',
        element: Customer,
        title: "Vendor",
        layout: MAIN,
        breadcrumb: ["Management", "Vendor"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/customer/add',
        element: CustomerAdd,
        title: "Customer Add",
        layout: MAIN,
        breadcrumb: ["Management", "Customer", "Add"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/customer/edit/:customerId',
        element: CustomerAdd,
        title: "Customer Edit",
        layout: MAIN,
        breadcrumb: ["Management", "Customer", "Edit"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/vendor/add',
        element: CustomerAdd,
        title: "Vendor Add",
        layout: MAIN,
        breadcrumb: ["Management", "Vendor", "Add"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/vendor/edit/:customerId',
        element: CustomerAdd,
        title: "Vendor Edit",
        layout: MAIN,
        breadcrumb: ["Management", "Vendor", "Edit"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
    {
        path: '/roles-permission',
        element: RolesPermission,
        title: "Roles & Permission",
        layout: DASHBOARD_LAYOUT,
        breadcrumb: ["Management", "Roles & Permission"],
        allowedRoles: [SUPER_ADMIN, ADMIN]
    },
    {
        path: '/roles-permission/add',
        element: RolesPermissionForm,
        title: "Roles & Permission",
        layout: MAIN,
        breadcrumb: ["Management", "Roles & Permission", "Add"],
        allowedRoles: [SUPER_ADMIN]
    },

    // Other
    {
        path: '/reports-analytics',
        element: ReportsAnalytics,
        title: "Reports & Analytics",
        layout: MAIN,
        breadcrumb: ["Other", "Reports & Analytics"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE]
    },

    // purchase
    {
        path: '/purchase',
        element: Purchase,
        title: "Purchase",
        layout: MAIN,
        breadcrumb: ["Management", "Purchase"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE]
    },
    {
        path: '/purchase/add',
        element: PurchaseForm,
        title: "Purchase Add",
        layout: MAIN,
        breadcrumb: ["Management", "Purchase", "Add"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE]
    },
    {
        path: '/purchase/edit/:purchaseId',
        element: PurchaseForm,
        title: "Purchase Edit",
        layout: MAIN,
        breadcrumb: ["Management", "Purchase", "Edit"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE]
    },
    {
        path: '/payment',
        element: Payment,
        title: "Payment",
        layout: MAIN,
        breadcrumb: ["Management", "Payment"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE]
    },
    {
        path: '/payment/add',
        element: PaymentForm,
        title: "Payment Add",
        layout: MAIN,
        breadcrumb: ["Management", "Payment", "Add"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE]
    },
    {
        path: '/payment/preview/:paymentId',
        element: PaymentPreview,
        title: "Payment Preview",
        layout: MAIN,
        breadcrumb: ["Management", "Payment", "Preview"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE]
    },

    // Profile Update
    {
        path: '/profile-update',
        element: ProfileUpdate,
        title: "Profile Update",
        layout: DASHBOARD_LAYOUT,
        breadcrumb: ["Profile Update"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },

    // Password Change
    {
        path: '/password-change',
        element: PasswordChange,
        title: "Password Change",
        layout: DASHBOARD_LAYOUT,
        breadcrumb: ["Password Change"],
        allowedRoles: [SUPER_ADMIN, ADMIN, FINANCE, SALES]
    },
];